import Pagination from './pagination-view';
import {getListing, updateListing} from "src/features/ui/listing";
import {connect} from "react-redux";

export default connect(
  (state, {listingId}) => {
    const {currentPage, count, pageSize, error} = getListing(state)(listingId);
    const totalPages = Math.ceil(count / pageSize) || 0;

    return {
      currentPage,
      totalPages,
      pageSize,
      count,
      error,
    };
  },
  (dispatch, {listingId, setPage}) => {
    return {
      setPage: setPage || (page => dispatch(updateListing({id: listingId, currentPage: page}))),
    };
  },
)(Pagination);
